import { Button } from "react-bootstrap"

export default function WeekTabs({ week, selectedDate, setSelectedDate }) {

  const formatDate = (day) => {
    const month = day.month || new Date(day.full).getMonth() + 1
    return `${day.day}/${month}`
  }


  return (
    <div className="week-tabs">

      {week.map(day => (
        <Button
          key={day.full}
          className={selectedDate === day.full ? "active-day" : "day-btn"}
          onClick={() => setSelectedDate(day.full)}
        >
          <div className="day-label">{day.label}</div>
          <div className="day-date">{formatDate(day)}</div>
        </Button>
      ))}

    </div>
  )
}